module.exports = {"className":"Screen","classNameLabel":"Screen","limit":5,"deleteColumn":"pageName","columns":[{"columnName":"objectId","type":"string"},{"columnName":"pageName","columnLabel":"page name","type":"string"},{"columnName":"createdAt","type":"Date"},{"columnName":"updatedAt","type":"Date"}]}


//////////////////
// WEBPACK FOOTER
// ./components/schema/Screen.json
// module id = 1239
// module chunks = 0